import create from "zustand"

export type TokenType = {
	id: number
	name: string,
	symbol: string,
	price: string,
	decimals: string
	rate: string
	logo: string
	status: {
		value: string,
		label: string
	},
	is_enabled_wallet: boolean
	updated_at: string
	price_vnd: string
}

export type FiatType = {
	id: number
	name: string,
	symbol: string,
	rate_usd: string,
	image: string
	currency_code: string
	logo: string
	status: {
		value: string,
		label: string
	}
}

type TokenStoreType = {
	tokenList: TokenType[] | null
	setTokenList: (list: TokenType[]) => void

	tokenFrom: TokenType | null
	setTokenFrom: (token: TokenType) => void

	fiatList: FiatType[] | null
	setFiatList: (list: FiatType[]) => void

	fiatTo: FiatType | null
	setFiatTo: (token: FiatType) => void
}

export const useTokenStore = create<TokenStoreType>((set) => ({
	tokenList: null,
	setTokenList: (tokenList: TokenType[]) => set(() => ({ tokenList })),

	tokenFrom: null,
	setTokenFrom: (token: TokenType) => set(() => ({ tokenFrom: token })),

	fiatList: null,
	setFiatList: (fiatList: FiatType[]) => set(() => ({ fiatList })),

	fiatTo: null,
	setFiatTo: (fiat: FiatType) => set(() => ({ fiatTo: fiat })),
}))
